export interface Language {
    name: string;
    icon: string;
    locale: string;
}

export const SUPPORTED_LANGUAGES: Language[] = [
    {
        name: 'german',
        icon: 'de',
        locale: 'de-DE'
    },
    {
        name: 'english',
        icon: 'en',
        locale: 'en'
    }
];
